import React from 'react';
import './FinanceFilters.css';

const FinanceFilters = ({ filters, onChange, restaurantOptions = [], driverOptions = [], activeTab }) => {
  return (
    <div className="finance-filters">
      <div className="filter-group">
        <label>الفترة:</label>
        <select
          value={filters.dateRange}
          onChange={(e) => onChange({ ...filters, dateRange: e.target.value })}
        >
          <option value="day">اليوم</option>
          <option value="month">هذا الشهر</option>
          <option value="year">هذه السنة</option>
        </select>
      </div>

      <div className="filter-group">
        <label>الاسم:</label>
        <input
          type="text"
          placeholder="ابحث بالاسم..."
          value={filters.name}
          onChange={(e) => onChange({ ...filters, name: e.target.value })}
        />
      </div>

      <div className="filter-group">
        <label>الحالة:</label>
        <select
          value={filters.status}
          onChange={(e) => onChange({ ...filters, status: e.target.value })}
        >
          <option value="all">الكل</option>
          <option value="تم التسليم ✅">تم التسليم</option>
          <option value="جاري التوصيل 🚚">جاري التوصيل</option>
          <option value="ملغي ❌">ملغي</option>
          <option value="جديد">جديد</option>
        </select>
      </div>

      {activeTab === 'restaurants' && (
        <div className="filter-group">
          <label>المطعم:</label>
          <select
            value={filters.restaurant}
            onChange={(e) => onChange({ ...filters, restaurant: e.target.value })}
          >
            <option value="">كل المطاعم</option>
            {restaurantOptions.map((restaurant) => (
              <option key={restaurant.id} value={restaurant.id}>
                {restaurant.name}
              </option>
            ))}
          </select>
        </div>
      )}

      {activeTab === 'drivers' && (
        <div className="filter-group">
          <label>السائق:</label>
          <select
            value={filters.driver}
            onChange={(e) => onChange({ ...filters, driver: e.target.value })}
          >
            <option value="">كل السائقين</option>
            {driverOptions.map((driver) => (
              <option key={driver.id} value={driver.id}>
                {driver.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default FinanceFilters;
